import React, { Component } from 'react';
import Styled from './styles';
import { Button, Select, FormControl, MenuItem } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import DownloadIcon from '@material-ui/icons/VerticalAlignBottom';
import api from '../../../lib/api';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

const styles = theme => ({
  selectDropDown: {
    marginRight: theme.spacing.unit,
    width: 119,
    border: '1px solid #C4C4C4',
    padding: '10px',
    borderRadius: 8,
    textTransform: 'capitalize',
    marginBottom: 14
  },
  selectMenu: {
    whiteSpace: 'normal',
    textOverFlow: ''
  },
  button: {
    borderRadius: 8,
    width: 264,
    height: 53,
    backgroundColor: '#31BC5F',
    color: '#FFF',
    display: 'flex',

    justifyContent: 'space-between',
    fontSize: 16,
    fontWeight: 700,
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#31BC5F'
    }
  }
});
const SELECT_NONE = 'Select None';
const selectedOptionsTitle = {
  cities: 'city',
  states: 'state',
  industries: 'industry',
  userTypes: 'user type'
};
class CatalogueSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filtersData: {},
      filterOptionSelected: false,
      optionsSelected: {},
      cataloguesData: [],
      loading: false,
      getCataloguesLoader: false,
      getFiltersLoader: false,
      error: false
    };
  }

  componentDidMount() {
    this.getFiltersForCatalogueSearch();
  }

  getFiltersForCatalogueSearch = async () => {
    try {
      this.setState({ getFiltersLoader: true });
      const data = await api.getFilterDetails();
      this.setState({ filtersData: data, getFiltersLoader: false });
    } catch (error) {
      this.setState({ getFiltersLoader: false, error: true });
    }
  };
  downloadFileFromLink = (link, fileName) => {
    const a = document.createElement('a');
    a.href = link;
    if (fileName) {
      a.download = fileName;
    }
    a.click();
  };
  onDownLoadClick = async () => {
    const { optionsSelected } = this.state;
    const finalData = {
      ...(optionsSelected['cities'] && { city: optionsSelected['cities'] }),
      ...(optionsSelected['states'] && { state: optionsSelected['states'] }),
      ...(optionsSelected['industries'] && {
        industry: optionsSelected['industries']
      }),
      ...(optionsSelected['userTypes'] && {
        userType: optionsSelected['userTypes']
      })
    };
    try {
      this.setState({ loading: true });
      const { pdfLink, fileName } = await api.downloadCatalogue(finalData);
      this.downloadFileFromLink(pdfLink, fileName);
      this.setState({ loading: false });
    } catch (error) {
      this.setState({ loading: false, error: true });
    }
  };
  getCatalogues = async selectedOption => {
    try {
      this.setState({ getCataloguesLoader: true });
      const data = { ...selectedOption };
      const finalData = {
        ...(data['cities'] && { city: data['cities'] }),
        ...(data['states'] && { state: data['states'] }),
        ...(data['industries'] && { industry: data['industries'] }),
        ...(data['userTypes'] && { userType: data['userTypes'] })
      };

      const response = await api.getCataloguesData(finalData);
      this.setState({
        cataloguesData: response,
        filterOptionSelected: true,
        getCataloguesLoader: false
      });
    } catch (error) {
      this.setState({
        getCataloguesLoader: false,
        error: true,
        filterOptionSelected: false
      });
    }
  };

  onOptionSelected = e => {
    e.preventDefault();
    e.stopPropagation();
    const { name, value } = e.target;
    const { optionsSelected } = this.state;
    const copiedValue = { ...optionsSelected };
    if (value === SELECT_NONE) {
      if (copiedValue[name]) {
        delete copiedValue[name];
        this.setState({ optionsSelected: copiedValue });

        if (Object.keys(copiedValue).length === 0) {
          this.setState({ filterOptionSelected: false });
          return;
        }
        this.getCatalogues(copiedValue);
      }
      return;
    }

    this.setState({
      optionsSelected: { ...copiedValue, [name]: value }
    });
    this.getCatalogues({ ...copiedValue, [name]: value });
  };
  onSnackbarClose = () => {
    this.setState({ error: false });
  };
  renderSearchCatalogueLeftContent = () => {
    const { classes } = this.props;
    const { filtersData, optionsSelected } = this.state;
    if (!Object.keys(filtersData).length) {
      return null;
    }
    return Object.keys(filtersData).map((item, index) => {
      return (
        <div key={index}>
          <FormControl>
            <Select
              key={index}
              className={classes.selectDropDown}
              classes={{
                select: classes.selectMenu
              }}
              disableUnderline
              value={optionsSelected[item] || item}
              type={'text'}
              onChange={this.onOptionSelected}
              name={item}
            >
              <MenuItem
                key={item}
                value={item}
                disabled
                style={{ textTransform: 'capitalize' }}
              >
                {selectedOptionsTitle[item]}
              </MenuItem>
              <MenuItem
                key={index}
                value={SELECT_NONE}
                style={{ textTransform: 'capitalize' }}
              >
                {SELECT_NONE}
              </MenuItem>
              {filtersData[item].map((option, index) => {
                return (
                  <MenuItem
                    key={index}
                    value={option}
                    style={{ textTransform: 'capitalize' }}
                  >
                    {option.split('_').join(' ')}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </div>
      );
    });
  };
  renderSearchCatalogueRightContent = () => {
    const { classes } = this.props;
    const {
      filterOptionSelected,
      loading,
      cataloguesData,
      filtersData
    } = this.state;

    if (!Array.isArray(cataloguesData)) {
      return null;
    }
    if (!Object.keys(filtersData).length) {
      return <Styled.Error>Could not fetch filters</Styled.Error>;
    }
    return (
      <div>
        {filterOptionSelected && !!cataloguesData.length && (
          <Styled.DownloadAndLoaderContainer>
            <Button
              classes={{ root: classes.button }}
              onClick={this.onDownLoadClick}
            >
              Download PDF
              <DownloadIcon nativeColor="white" />
            </Button>
            {loading && (
              <Styled.DownloadLoader>
                <CircularProgress size={20} thickness={5} color="primary" />
              </Styled.DownloadLoader>
            )}
          </Styled.DownloadAndLoaderContainer>
        )}
        {filterOptionSelected && cataloguesData.length === 0 && (
          <Styled.Error>
            Could not find any catalogue for the selected option.
          </Styled.Error>
        )}
        {filterOptionSelected && !!cataloguesData.length && (
          <Styled.CatalogueContainer>
            {cataloguesData.map((item, index) => {
              return (
                <Styled.CatalogueGridTileContainer
                  key={index}
                  href={item.catalogueLink}
                  target="_blank"
                >
                  <Styled.CatalogueGridTile>
                    <Styled.CatalogueImage
                      src={item.imageURL}
                      alt=""
                    ></Styled.CatalogueImage>
                  </Styled.CatalogueGridTile>
                  <Styled.CatalogueGridTileTitle>
                    {item.companyName}
                  </Styled.CatalogueGridTileTitle>
                </Styled.CatalogueGridTileContainer>
              );
            })}
          </Styled.CatalogueContainer>
        )}
        {!filterOptionSelected && (
          <Styled.InitialTitle>
            Please select city, state, industry or user type to search
            catalogue.
          </Styled.InitialTitle>
        )}
      </div>
    );
  };
  renderFiltersAndSearchCatalogueContent = () => {
    const { getCataloguesLoader } = this.state;
    return (
      <Styled.SearchCatalogueContent>
        <Styled.SearchCatalogueLeftContent>
          {this.renderSearchCatalogueLeftContent()}
        </Styled.SearchCatalogueLeftContent>
        <Styled.SearchCatalogueRightContent>
          {getCataloguesLoader ? (
            <Styled.GetCataloguesLoader>
              <CircularProgress size={20} thickness={5} color="primary" />
            </Styled.GetCataloguesLoader>
          ) : (
            this.renderSearchCatalogueRightContent()
          )}
        </Styled.SearchCatalogueRightContent>
      </Styled.SearchCatalogueContent>
    );
  };

  render() {
    const { getFiltersLoader, error } = this.state;
    return (
      <div>
        <Styled.SearchCatalogueContainer>
          <Styled.SearchCatalogueTitle>
            Catalogue Search
          </Styled.SearchCatalogueTitle>
          {getFiltersLoader ? (
            <Styled.LoaderContainer>
              <CircularProgress size={20} thickness={5} color="primary" />
            </Styled.LoaderContainer>
          ) : (
            this.renderFiltersAndSearchCatalogueContent()
          )}
        </Styled.SearchCatalogueContainer>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          open={error}
          autoHideDuration={6000}
          onClose={this.onSnackbarClose}
          message={'Something went wrong'}
          action={[
            <IconButton key={0} onClick={this.onSnackbarClose}>
              <CloseIcon nativeColor="#fff" />
            </IconButton>
          ]}
        />
      </div>
    );
  }
}
export default withStyles(styles)(CatalogueSearch);



// WEBPACK FOOTER //
// ./src/pages/SalesUtility/CatalogueSearch/index.js